/*
 * yodaSiteComponents registry entries for this microsite.
 *
 * Only the externalized shell set (header/footer/sliders, PM-312) — it comes
 * from the shared fragment in yoda-app-shell so every microsite carries the
 * identical definition. Add page-level entries here if this microsite starts
 * consuming its own federated components.
 */
const { getExternalizedShellRegistry } = require('yoda-app-shell/lib/mfe/externalMfComponents');

const yodaSiteComponents = {
    StickyBetween: {
        importFn: () => import('yodaSiteComponents/StickyBetween'),
        path: 'yodaSiteComponents/StickyBetween',
        type: 'functional',
        isSSR: false,
    },
    ...getExternalizedShellRegistry(),
};

module.exports = { yodaSiteComponents };
